module.exports = __webpack_public_path__ + "412b143858228a05e6964a722ae098f6.png";